import React, { Component } from "react";
import * as FlexLayout from "flexlayout-react";
import TradingMarkets from "./tradingMarkets";
import TradingMarket from "./tradingMarket";
import { withTranslation } from "react-i18next";

class TradingMarketAdmin extends Component {
  LAYOUT = {
    global: {
      minWidth: 100,
      minHeight: 100,
    },
    borders: [],
    layout: {
      type: "row",
      children: [
        {
          type: "tabset",
          weight: 50,
          enableMaximize: false,
          tabSetEnableTabStrip: false,
          children: [
            {
              type: "tab",
              name: this.props.t("TradingMarkets"),
              enableClose: false,
              component: "TradingMarkets",
            },
          ],
        },
        {
          //Figure out how to make this persistent even when empty.
          type: "tabset",
          id: "1",
          weight: 50,
          enableDeleteWhenEmpty: false,
          enableMaximize: false,
          children: [
            // {
            //   type: "tab",
            //   name: "User",
            //   visible: false,
            //   component: "Placeholder"
            // }
          ],
        },
      ],
    },
  };

  state = {
    model: FlexLayout.Model.fromJson(this.LAYOUT),
  };

  handleTradingMarketSelect = (TradingMarket, submitCallbackFunction, isNew) => {
    const { marketId, name } = TradingMarket;

    try {
      this.state.model.doAction(
        FlexLayout.Actions.addNode(
          {
            type: "tab",
            component: "TradingMarket",
            name: `${name}`,
            id: `${marketId}`,
            config: { marketId, submitCallbackFunction, isNew },
          },
          "1",
          FlexLayout.DockLocation.CENTER,
          0,
          true
        )
      );
    } catch {
      this.state.model.doAction(FlexLayout.Actions.selectTab(marketId));
    }
  };

  handleTabRename = (nodeId, marketId, name) => {
    this.state.model.doAction(
      FlexLayout.Actions.updateNodeAttributes(nodeId, { name: name, nodeId: marketId })
    );
  };

  factory = (node) => {
    const componentId = node.getComponent();
    //const TradingMarketId = node.getId();

    if (componentId === "TradingMarkets") {
      return (
        <TradingMarkets
          onClick={this.handleTradingMarketSelect}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "TradingMarket") {
      const { marketId, submitCallbackFunction, isNew } =
        node.getConfig();
      return (
        <TradingMarket
          marketId={marketId}
          submitCallbackFunction={submitCallbackFunction}
          isNew={isNew}
          onRename={this.handleTabRename}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Placeholder") {
      return <div></div>;
    } else {
      return null;
    }
  };

  buildFlexLayout = () => {
    return (
      <div className="flex-container">
        <FlexLayout.Layout model={this.state.model} factory={this.factory} />;
      </div>
    );
  };

  render() {
    return this.buildFlexLayout();
  }
}

export default withTranslation(["trading"])(TradingMarketAdmin);
